import React, { useState } from 'react';

const faqs = [
	{
		q: "Is this free to join?",
		a: "Yes. Joining the waitlist is completely free. There is no commitment and nothing to pay.",
	},
	{
		q: "When can I start using Kaftora?",
		a: "Kaftora is launching soon in Ghana. Waitlist members get priority access before we open to the public, meaning your profile goes live first, you get seen by early clients first, and you help shape how the platform works. Sign up now to secure your spot.",
	},
	{
		q: "I am a tailor with an existing business. Will Kaftora interfere with my current clients?",
		a: "Not at all. Kaftora is designed to bring you new clients you would not find otherwise — not to replace your existing relationships.",
	},
	{
		q: "How does payment work? will my money be safe?",
		a: "Kaftora uses escrow payments. Client payments are held securely until delivery is confirmed. Tailors get paid. Clients are protected.",
	},
	{
		q: "Will my existing clients be able to find me on Kaftora?",
		a: "Yes. Your Kaftora profile is fully yours.your name, your work, your reputation. Clients who already know you can find and book you directly on the platform, and new clients who have never heard of you can discover you too.",
	},
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section
      style={{
        padding: '80px 24px',
        background: 'var(--bg)',
      }}
    >
      <div style={{ maxWidth: '720px', margin: '0 auto' }}>
        
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>

          <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: '2.4rem',
            color: '#fff',
            fontWeight: 600
          }}>
            Questions, answered
          </h2>
        </div>

        {/* FAQ Items */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                style={{
                  border: '1px solid var(--border)',
                  borderRadius: '12px',
                  background: 'var(--surface)',
                  overflow: 'hidden',
                }}
              >
                {/* Question */}
                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  style={{
                    width: '100%',
                    textAlign: 'left',
                    padding: '18px',
                    background: 'transparent',
                    border: 'none',
                    color: '#fff',
                    fontSize: '1rem',
                    fontWeight: 500,
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {item.q}
                  <span style={{
                    color: 'var(--gold)',
                    fontSize: '1.2rem',
                    transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                    transition: '0.2s'
                  }}>
                    +
                  </span>
                </button>

                {/* Answer */}
                {isOpen && (
                  <div style={{
                    padding: '0 18px 18px',
                    color: 'var(--text-muted)',
                    fontSize: '0.9rem',
                    lineHeight: '1.6',
                  }}>
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}